import { create } from 'zustand'

type RewardResultModalStoreProps = {
  amountUsd: number
  balancePercentage: number
  calendarPercentage: number
  isOpen: boolean
  setAmountUsd: (amountUsd: number) => void
  setBalancePercentage: (balancePercentage: number) => void
  setCalendarPercentage: (calendarPercentage: number) => void
  setIsClose: () => void
  setIsOpen: () => void
  setTitle: (title: string) => void
  title: string
}

export const useRewardResultModalStore = create<RewardResultModalStoreProps>(
  (set) => ({
    isOpen: false,
    title: '',
    calendarPercentage: 0,
    balancePercentage: 0,
    amountUsd: 0,

    setAmountUsd: (amountUsd: number): void => set({ amountUsd }),
    setIsOpen: (): void => set({ isOpen: true }),
    setIsClose: (): void => set({ isOpen: false }),
    setTitle: (title: string): void => set({ title }),
    setCalendarPercentage: (calendarPercentage: number): void =>
      set({ calendarPercentage }),
    setBalancePercentage: (balancePercentage: number): void =>
      set({ balancePercentage }),
  })
)
